import { CodeSetting } from './CodeSetting';

export class CameraCodeSetting {
  /**
   * カメラオブジェクトを構成
   * @param {}} has_avator
   */
  static getCameraCursorCode(click_type = 'mouse', block_id: string): string {
    let subBlocks = '';
    subBlocks += ``;

    if (click_type === 'mouse') {
      subBlocks += CodeSetting.getElementCode(
        'a-entity',
        `   entity.setAttribute("id","cursor");
            entity.setAttribute("cursor", "rayOrigin: mouse;fuse:false");
            entity.setAttribute('raycaster', 'objects: .collidable');
            `,
        block_id,
        ''
      );
    } else if (click_type === 'cursor') {
      subBlocks += CodeSetting.getElementCode(
        'a-cursor',
        `
            entity.setAttribute("id","cursor");
            entity.setAttribute("cursor","fuse:true;far:1000;fuseTimeout:600")
            entity.setAttribute('raycaster', 'objects: .collidable');

            entity.setAttribute("animation__fusing","property: scale; startEvents: fusing; easing: easeInSine; dur: 300; from: 3 3 3; to: 1 1 1;");
            // entity.setAttribute("animation__click","property: scale; startEvents: click; easing: easeInSine; dur: 300; from: 1.5 1.5 1.5; to: 0.5 0.5 0.5;");
            entity.setAttribute("animation__mouseleave","property: scale; startEvents: mouseleave; easing: easeInSine; dur: 300; to: 1 1 1;");
        `,
        block_id,
        ''
      );
    } else if (click_type === 'cursor_mouse') {
      subBlocks += CodeSetting.getElementCode(
        'a-cursor',
        `
            entity.setAttribute("id","cursor");
            entity.setAttribute('raycaster', 'objects: .collidable');
            entity.setAttribute("scale","0.5 0.5");
            `,
        block_id,
        ''
      );
    }

    return subBlocks;
  }
}
